<template>
  <div
    class="dynamic-drop-down"
    :style="`
      max-width:${max_width}px;
      padding:${padding}px`"
  >
    <v-select
      :value="value"
      :items="items"
      :label="label"
      hide-details
      :placeholder="placeholder"
      :persistent-placeholder="placeholder ? true : false"
      :clearable="clearable"
      clear-icon="close"
      :disabled="disabled"
      :light="light"
      :color="getColor(foreground_color)"
      append-icon="arrow_drop_down"
      @change="$emit('selected', $event)"
    >
    <template v-slot:item="{ item, attrs, on }">
      <v-list-item v-on="on" v-bind="attrs">
          <TText v-if="translatable" :value="item"/>
          <TText v-else :text="item"/>
      </v-list-item>
    </template>
    </v-select>
  </div>
</template>

<script>
import { TColor } from '@/mixins/TColor.mixin.js';
import { WorkPackageWIPMixin } from '@/mixins/WorkPackageWIPMixin.mixin.js';
import TText from '@/components/Taktify/TText.component.vue'


  export default {
    mixins: [
      TColor,
      WorkPackageWIPMixin,
    ],
    components: {
      TText,
    },
    props: [
      'label',
      'value',
      'items',
      'default_item',
      'placeholder',
      'clearable',
      'disabled',
      'max_width', // is number, controls max-width of drop down
      'padding', // is number, controls padding of up/down and left/right
      'light',
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'translatable', // boolean if options are translatable
    ],

  }
</script>

<style>
  .dynamic-drop-down {
    /* max-width: 120px; */
    flex-grow: 1;
  }
  .dynamic-drop-down > .v-text-field {
    padding: 0;
    margin: 0;
  }
</style>
